import {Form, Image, Input, Modal, Select, Space, Typography} from "antd";
import "react-phone-input-2/lib/style.css";
import {useAppSelector} from "../../../../../hooks";
import {RootState} from "../../../../../redux/store/store";
import {
  Button,
  ContentTitle,
  CopyPromoCode,
  DFlex,
  Earned,
  Half,
  PromoCode,
  PromoCodeBox,
  PromoCodeTitle,
  ShareBtn,
  SmallText,
  SocialMediaBox,
  SocialMediaWrapper,
  VehicleWrapper
} from "./styles";
import {ReactComponent as CopyIcon} from "../../../../../assets/icons/copy.svg";
import {ReactComponent as ShareIcon} from "../../../../../assets/icons/share.svg";
import {useState} from "react";
import {useNavigate} from "react-router-dom";

import {
  EmailIcon,
  EmailShareButton,
  OKIcon,
  OKShareButton,
  TelegramIcon,
  TelegramShareButton,
  ViberIcon,
  ViberShareButton,
  VKIcon,
  VKShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

const {Option} = Select;

interface Vehicle {
  categoryId: number;
  model: string;
  id: number;
  stateNumber: string;
  brand: string;
}

interface VehCat {
  id: number;
  title: string;
}

interface VehPhoto {
  id: number;
  ownerId: number;
  vehicleId: number;
  photo: string;
}

interface Props {
  form: any;
  onFinish: any;
  onFinishFailed: any;
  formData: any;
  vehicle: string | null;
  setVehicleHandler: (value: string) => void;
  vehPhoto: VehPhoto[] | [];
  currentUser: any;
}

const refLink = {
  value: "https://web.rukki.pro/r/",
  label: "web.rukki.pro/r/",
};

const ErrorFallBack = ({size}: { size: string }) => (
    <Image
        width={size}
        height={size}
        src="error"
        fallback="data:image/png;base64,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"
    />
);

const shares = [
  {
    Icon: EmailShareButton,
    Children: EmailIcon,
  },
  {
    Icon: OKShareButton,
    Children: OKIcon,
  },
  {
    Icon: TelegramShareButton,
    Children: TelegramIcon,
  },
  {
    Icon: ViberShareButton,
    Children: ViberIcon,
  },
  {
    Icon: VKShareButton,
    Children: VKIcon,
  },
  {
    Icon: WhatsappShareButton,
    Children: WhatsappIcon,
  },
];

const UserInfoFormDocs: React.FC<Props> = (
    {
      form,
      onFinish,
      onFinishFailed,
      formData,
      vehicle,
      setVehicleHandler,
      vehPhoto,
      currentUser,
    }) => {
  const {vehicleCategories} = useAppSelector(
      (state: RootState) => state.vehicles
  );

  const [shareLink, setShareLink] = useState(false);

  const navigate = useNavigate();

  if ((Object.keys(formData).length = 0)) return <div>Загрузка...</div>;

  return (
      <>
        <Modal
            // visible={shareLink}
            open={shareLink}
            centered
            onCancel={() => setShareLink(false)}
            footer=""
            title="Поделитесь ссылкой с друзьями"
        >
          <SocialMediaWrapper>
            {shares.map(({Icon, Children}, index) => (
                <SocialMediaBox key={`shares${index}`}>
                  <Icon url={`${refLink.value}${currentUser?.customer?.refId}`}>
                    <Children/>
                  </Icon>
                </SocialMediaBox>
            ))}
            <ShareBtn
                onClick={() => {
                  navigator.clipboard
                      .writeText(`${refLink.value}${currentUser?.customer?.refId}`)
                      .then(() => {
                        // toast.success("промо-код скопирован");
                      })
                      .catch(() => {
                        // toast.error("что-то пошло не так");
                      });
                }}
            >
              <CopyIcon/>
              {refLink.label}
              {currentUser?.customer?.refId}
            </ShareBtn>
          </SocialMediaWrapper>
        </Modal>
        <Typography.Title level={4}>Документы</Typography.Title>
        <Space direction="horizontal">
          {currentUser?.customer?.passportMainPage ? (
              <Image
                  width={150}
                  src={`data:image/png;base64, ${currentUser?.customer?.passportMainPage}`}
              />
          ) : (
              <ErrorFallBack size="150"/>
          )}
          {currentUser?.customer?.passportRegistrationPage ? (
              <Image
                  width={150}
                  src={`data:image/png;base64, ${currentUser.customer.passportRegistrationPage}`}
              />
          ) : (
              <ErrorFallBack size="150"/>
          )}
        </Space>
        <VehicleWrapper>
          <Typography.Title level={4}>Техника</Typography.Title>
          <Select
              placeholder="Техника"
              style={{width: "200px"}}
              value={vehicle?.toString()}
              onSelect={(value: string) => {
                setVehicleHandler(value);
              }}
          >
            {vehicle &&
                formData &&
                formData.vehicles &&
                formData.vehicles.map((item: Vehicle, index: number) => (
                    <Option key={`vehcat${index}`} value={`${item.id}`}>
                      {item.brand}
                    </Option>
                ))}
          </Select>
        </VehicleWrapper>
        <Form
            form={form}
            labelAlign="left"
            size="large"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
          <Form.Item name="vehCatId" label="Тип">
            <Select placeholder="Техника">
              {vehicleCategories.map((item: VehCat, index: number) => (
                  <Option key={`vehcat${index}`} value={item.id}>
                    {item.title}
                  </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
              name="vehBrand"
              label="Марка"
              rules={[
                {
                  message: "Марка",
                },
              ]}
          >
            <Input/>
          </Form.Item>
          <Form.Item
              name="vehModel"
              label="Модель"
              rules={[
                {
                  message: "Модель",
                },
              ]}
          >
            <Input/>
          </Form.Item>
          <Form.Item
              name="vehStateNumber"
              label="Гос. знак"
              rules={[
                {
                  message: "Гос. знак",
                },
              ]}
          >
            <Input/>
          </Form.Item>
          <Typography.Title level={4}>Фотографии</Typography.Title>
          <Space direction="horizontal">
            {vehPhoto && vehPhoto.length > 0 ? (
                vehPhoto.map((item: VehPhoto, index: number) => {
                  return (
                      <Image
                          key={`veh${index}`}
                          width={100}
                          src={`https://api.rukki.pro/api/customers/image/${item.photo}`}
                      />
                  );
                })
            ) : (
                <ErrorFallBack size="100"/>
            )}
          </Space>
          <DFlex>
            <Half>
              <ContentTitle>Вы заработали</ContentTitle>
              <Earned>{currentUser && currentUser?.reward && currentUser?.reward?.total} ₽</Earned>
              <SmallText>
                И пригласили {currentUser?.registrations?.length || 0} пользователей
              </SmallText>
              <Button
                  onClick={() => navigate("/finance?from=invite")}
                  style={{marginTop: "24px"}}
              >
                Получить выплату
              </Button>
            </Half>
            <Half>
              <PromoCodeTitle>Ваш промо-код</PromoCodeTitle>
              <PromoCodeBox>
                <PromoCode>{currentUser?.customer?.refId}</PromoCode>
                <CopyPromoCode
                    onClick={() => {
                      navigator.clipboard
                          .writeText(`${refLink.value}${currentUser?.customer?.refId}`)
                          .then(() => {
                            // toast.success("промо-код скопирован");
                          })
                          .catch(() => {
                            // toast.error("что-то пошло не так");
                          });
                    }}
                >
                  <CopyIcon/>
                  Скопировать
                </CopyPromoCode>
              </PromoCodeBox>
              <SmallText>
                Отправьте этот код со скидкой вашим коллегам. Когда они завершат
                свою сделку, вы получите вознаграждение
              </SmallText>
              <ShareBtn onClick={() => setShareLink(true)}>
                <ShareIcon/>
                {refLink?.label}
                {currentUser?.customer?.refId}
              </ShareBtn>
            </Half>
          </DFlex>
        </Form>
      </>
  );
};

export default UserInfoFormDocs;
